module.exports = __webpack_public_path__ + "img/tz.9043b37f.svg";